/**
 * 🛰️ SEC_00_DB_PAYLOAD
 * ----------------------------------------------------------------------------
 * Standards: 
 * - Two-way communication: SEND (POST) and GET (Retrieval).
 * - Empty X-INTENT forces Doorman.cs to route via Postman.
 * - Injects siteUserGuid/sessionID into POST bodies for .NET DTO alignment.
 */

const API_BASE = process.env.REACT_APP_API_BASE_URL || "";

/**
 * 🛡️ Core DB Interrogation Engine
 */
export const dbPayload = async (endpoint, method = "GET", siteKey, body = {}) => {
  
  // 1. Extract session assets (GUID, SessionID) already in storage
  const sessionId = sessionStorage.getItem('SEC_SESSION_ID');
  const userGuid = sessionStorage.getItem('SEC_USER_GUID');

  // 2. Build headers with explicit empty X-INTENT to trigger Postman
  const headers = {
    "Content-Type": "application/json",
    "SITE-KEY": siteKey,
    "X-INTENT": "", 
    "Authorization": `Bearer ${sessionId}`,
    "X-SEC-USER-GUID": userGuid,
    "X-SEC-SESSION-ID": sessionId,
    "X-TIMESTAMP": Math.floor(Date.now() / 1000).toString(),
  };

  // 3. DIRECTIONAL LOGIC
  let fetchOptions = { method, headers };

  if (method.toUpperCase() === "POST") {
    // SEND DIRECTION: Braid session markers into the DTO for .NET
    const enhancedBody = {
      ...body,
      siteUserGuid: userGuid,
      sessionID: sessionId
    };
    fetchOptions.body = JSON.stringify(enhancedBody);
  }

  // 4. EXECUTE HANDSHAKE
  const response = await fetch(`${API_BASE}${endpoint}`, fetchOptions);

  if (!response.ok) {
    throw new Error(`DB Gateway Exception: ${response.status}`);
  }

  // GET DIRECTION: Return the normalized result from nrgCore
  return await response.json();
};